import { OfferSettingsState } from './duck';
import { createSelector } from '~/helpers/util/selectors';

export const getRoot = (state: any) => {
  return state.core.offerSettings as OfferSettingsState;
};

export const getById = createSelector([getRoot], state => state.byId);
